import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { PopoverService } from '../../../components/popover/popover.service';
import { ToolbarUserDropdownComponent } from './toolbar-user-dropdown/toolbar-user-dropdown.component';
import icPerson from '@iconify/icons-ic/twotone-person';
import {LocalStoreService} from "../../../services/local-store.service";
import {AuthServiceLocal} from '../../../services/auth.service';

@Component({
  selector: 'vex-toolbar-user',
  templateUrl: './toolbar-user.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToolbarUserComponent implements OnInit {
  userProfilePic;
  dropdownOpen: boolean;
  icPerson = icPerson;
  AdminDetails ;

  constructor(private popover: PopoverService,
              private cd: ChangeDetectorRef,
              private auth: AuthServiceLocal) {
    this.AdminDetails = this.auth.getUser();
  }

  ngOnInit() {
    
    this.auth.userProfilePic.next(JSON.parse(localStorage.getItem('loggedUser'))?.profileImage);

    this.auth.userProfilePic.subscribe((res)=>{
      console.log("resuserProfilePic", res);
      this.userProfilePic = res;
      this.cd.detectChanges();
    })

  }

  showPopover(originRef: HTMLElement) {
    this.dropdownOpen = true;
    this.cd.markForCheck();

    const popoverRef = this.popover.open({
      content: ToolbarUserDropdownComponent,
      origin: originRef,
      offsetY: 12,
      position: [
        {
          originX: 'center',
          originY: 'top',
          overlayX: 'center',
          overlayY: 'bottom'
        },
        {
          originX: 'end',
          originY: 'bottom',
          overlayX: 'end',
          overlayY: 'top',
        },
      ]
    });

    popoverRef.afterClosed$.subscribe(() => {
      this.dropdownOpen = false;
      this.cd.markForCheck();
    });
  }
}
